import API, { gatewayFetch } from 'helpers/api';
import { bulkOpsUrl } from 'config/baseURL';
import { getInternalToken } from 'services/bulkOpsRevamp/bulkEdit.service';
import { APIResponse } from 'core/domain/models/api';

export interface BulkUploadResponse {
	data: string; // bulkOperationsID
	error: null | string;
}

export interface BulkOperationStatus {
	bulkOperationID: string;
	organizationID: string;
	stage: 'uploading' | 'validating' | 'validation-failed' | 'creating-entities' | 'done' | 'failed';
	validationErrors: Array<{
		entityName: string;
		errors: Array<{
			field: string;
			line: number;
			message: string;
		}>;
	}>;
	entityDetails: Array<{
		entity: string;
		mode: string;
		count: number;
	}>;
}

export type BulkOperationStatusResponse = APIResponse<BulkOperationStatus>;

export interface TemplateDownloadResponse {
	data: string; // signed URL
	error: null | string;
}

export const uploadLMSFile = async (file: File): Promise<BulkUploadResponse> => {
	const formData = new FormData();
	formData.append('file', file);

	const url = `${bulkOpsUrl}/lms`;
	const firebaseToken = await API.getFirebaseToken();
	const token = await getInternalToken(firebaseToken, url);

	const response = await gatewayFetch(url, {
		method: 'POST',
		headers: {
			authorization: token,
		},
		body: formData,
	});

	if (!response.ok) {
		throw new Error('Failed to upload file');
	}

	return response.json();
};

export const getBulkOperationStatus = async (bulkOperationId: string): Promise<BulkOperationStatusResponse> => {
	const url = `${bulkOpsUrl}/${bulkOperationId}`;
	const firebaseToken = await API.getFirebaseToken();
	const token = await getInternalToken(firebaseToken, url);

	const result = await API.getJSON(url, token);
	if (!result) {
		throw new Error('Failed to get bulk operation status');
	}
	return result.data as BulkOperationStatusResponse;
};

export const downloadLMSTemplate = async (): Promise<TemplateDownloadResponse> => {
	const url = `${bulkOpsUrl}/lms/bulk-edit/download`;
	const firebaseToken = await API.getFirebaseToken();
	const token = await getInternalToken(firebaseToken, url);

	const result = await API.getJSON<TemplateDownloadResponse>(url, token);
	if (!result) {
		throw new Error('Failed to download template');
	}
	return result;
};

export const downloadLMSBulkUploadBlankTemplate = async (): Promise<TemplateDownloadResponse> => {
	const url = `${bulkOpsUrl}/lms/bulk-upload/template`;
	const firebaseToken = await API.getFirebaseToken();
	const token = await getInternalToken(firebaseToken, url);

	const result = await API.getJSON<TemplateDownloadResponse>(url, token);
	if (!result) {
		throw new Error('Failed to download bulk upload template');
	}
	return result;
};
